// extracted by mini-css-extract-plugin
module.exports = {"actions":"Table_actions__1WKGM","colMaxWidth":"Table_colMaxWidth__1BzC8"};